import { enumToSentence } from "common/utils";

export function getFilterLabel(filterType) {
    let filterLabel = enumToSentence(filterType);
    if (filterType === "DairyGrassFedFeed") {
        filterLabel = "Wet matter from grass-fed feed";
    }
    if (filterType === "DairyTimeWithAccessToPasture") {
        filterLabel = "Time grazing outdoors";
    }
    if (filterType === "DairyGrazingDays") {
        filterLabel = "Grazing days";
    }
    return filterLabel;
}